import React, { useState } from 'react';
import { connect } from 'react-redux';
import {  } from '../../../redux';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import "./index.css";


function NewQuestionForm (props) {
    const {
        addNewQuestion,
        handleClick,
    } = props;

    const [question, setQuestion] = useState("");
    const [answer, setAnswer] = useState(null);


    const handleChange = (e) => {
        setQuestion(e.target.value);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        addNewQuestion({question, answer});

        setQuestion("");
        setAnswer(null);

        handleClick();
    }

    const handleDropdownChange = (e) => {
        setAnswer(e.target.innerText.trim());
    }

    return (
        <form onSubmit={handleSubmit} className="questionForm">
            <h2>New Question</h2>
            <TextField
                hintText="Question Text"
                style={{paddingTop: "0px", paddingBottom: "20px"}}
                name="question"
                onChange={handleChange}
                value={question}
                multiLine={true}
                rows={1}
            />
            <br/>
            <SelectField
                hintText={"Response Type"}
                name="answer"
                value={answer}
                onChange={handleDropdownChange}
                labelStyle={{textAlign: "left"}}
                floatingLabelStyle={{paddingLeft: "0%"}}
                style={{textAlign: "left"}}
            >
                <MenuItem
                    key="0text"
                    value="Text"
                    primaryText="Text"
                    id="answer"
                />
                <MenuItem
                    key="1range"
                    value="Range"
                    primaryText="Range"
                    id="answer"
                />
                <MenuItem
                    key="2yn"
                    value="Y/N"
                    primaryText="Y/N"
                    id="answer"
                />
            </SelectField>
            <br/>
            <button type="submit" className="actionButton assignmentQuestion">Add</button>
            <button onClick={handleClick} className="actionButton assignmentQuestion">Clear</button>
        </form>
    );
}

export default connect(state => state.root, {  })(NewQuestionForm);
